import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-2 w-full" }
const _hoisted_2 = { class: "text-brown text-base leading-[20px] select-none sf-pro" }
const _hoisted_3 = ["type", "value"]




export default /*@__PURE__*/_defineComponent({
  __name: 'TextInput',
  props: {
    label: {},
    modelValue: {},
    type: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {



const emits = __emit;

function handleInput(event: Event) {
  emits("update:modelValue", (event.target as HTMLInputElement).value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, _toDisplayString(__props.label), 1),
    _createElementVNode("input", {
      class: "w-full h-[52px] rounded-[14px] border border-muted px-4 text-brown focus:outline-none sf-pro",
      type: __props.type,
      value: __props.modelValue,
      onInput: _cache[0] || (_cache[0] = ($event: any) => (handleInput($event)))
    }, null, 40, _hoisted_3)
  ]))
}
}

})